export interface StripeCloseModalActionType {
  type: '@stripe/CLOSE_MODAL';
}

export const closeModal = (): StripeCloseModalActionType => ({
  type: '@stripe/CLOSE_MODAL',
});
